import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';
import miscUtils from '../../../utils/miscUtils';

class DocMoneyEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 id="money" className="heading-1">Money</h3>
                    <div className="description">
                        The extraction of currency values is based on the identification of one or more
                        attributes that surround the core numeric digit amount. The amount value is
                        standardized to a decimal representation in the normalizedAmount attribute.
                        An extracted currency may be represented by the following attributes:
                    </div>

                    <table className="table-wrapper">
                        <thead className="table-header">
                        <tr>
                            <th>Attribute </th>
                            <th>Meaning </th>
                            <th>Type </th>
                            <th>Constraints </th>
                            <th>Notes </th>
                        </tr>
                        </thead>
                        <tbody className="table-body">
                        <tr>
                            <td className="attribute">symbol</td>
                            <td className="meaning">Currency Symbol</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">Currency symbol (e.g., $, €, £)
                                Abbreviations that include a dollar sign (e.g. A$, HK$, NT$)
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">amount</td>
                            <td className="meaning">Numeric digit amount</td>
                            <td className="type">String</td>
                            <td className="constraints">Mandatory</td>
                            <td className="notes">Accommodates various international styles
                                (e.g., "1,234,567.89", "1 234 567,89", "1 234 567.89")
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">amountModifier</td>
                            <td className="meaning">Term that modifies the amount</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">A term that modifies the amount size (e.g., hundred, K, thousand, M)</td>
                        </tr>
                        <tr>
                            <td className="attribute">term</td>
                            <td className="meaning">Currency terms</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">Terms that indicate a currency (e.g., dollar, euro, pound)</td>

                        </tr>
                        <tr>
                            <td className="attribute">normalizedAmount</td>
                            <td className="meaning">Decimal representation of the amount</td>
                            <td className="type">Number</td>
                            <td className="constraints">Mandatory</td>
                            <td className="notes">Decimal representation of the value created by standardizing the amount to a sequence
                                of zero or more decimal digits ("the integer"), optionally followed by a fraction, and
                                combining this value with the amountModifier, if present, to produce a final value.
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">currencyCode</td>
                            <td className="meaning">{miscUtils.createExternalLink('https://www.iso.org/iso-4217-currency-codes.html','ISO 4217 alphabetic currency code')}</td>
                            <td className="type">JSON Array</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">JSON array containing either a 
                                single {miscUtils.createExternalLink('https://www.iso.org/iso-4217-currency-codes.html','ISO 4217 alphabetic currency code')} (e.g., USD, EUR, GBP) 
                                captured by the pattern, or one or more currency codes inferred from the symbol
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">countryNames</td>
                            <td className="meaning">Country names</td>
                            <td className="type">JSON Array</td>
                            <td className="constraints">Optional</td>
                            <td className="notes"> JSON array containing country names associated with a single currency code</td>
                        </tr>
                        </tbody>
                    </table>

                    <h4 className="heading-2">Examples</h4>
                    <div className="example-content">Dollar Amount: $38.38</div>
                    <HttpRunner example="money1"
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_MONEY1) : null}
                    />
                    <br/>
                    <div className="example-content">Foreign Currency: 156 billion rubles</div>
                    <HttpRunner example="money2" 
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_MONEY2) : null}
                    />
                </div>
            </div>
        );
    }
}

export default DocMoneyEntity;